import { Box } from '@mui/material'; // Assuming you're using Material-UI
import { ReactNode } from 'react';

interface PIIHighlightStyling {
  id: string;
  min: number;
  max: number;
  style: {
    content: ({ children }: { children: ReactNode }) => JSX.Element;
  };
}

export const getPIIHighlightStyling = (text: string): PIIHighlightStyling[] => {
  const piiHighlights: PIIHighlightStyling[] = [];
  const piiPattern = /<([^>]+)>/g;

  for (const match of text.matchAll(piiPattern)) {
    // Example: "Some text is here <PII INFO> and here."
    const fullMatch = match[0]; // "<PII INFO>"
    const piiContent = match[1]; // "PII INFO"

    if (piiContent.trim().length > 0) {
      piiHighlights.push({
        id: `pii-${piiContent.trim()}`,
        min: match.index,
        max: match.index + fullMatch.length,
        style: {
          content: ({ children }: { children: ReactNode }) => (
            <Box
              component="span"
              color={(theme) => theme.palette.text.disabled}
            >
              {children}
            </Box>
          ),
        },
      });
    }
  }

  return piiHighlights;
};
